import { api } from "../utils/apiClient";

/**
 * Fetch the authenticated user's current-period usage + limits for every metered feature (audits,
 * prompt_tests, persona_reports, ota_queries).
 *
 * @returns {Promise} Axios response — data: { plan, features: [{ feature, used, limit, remaining,
 *   unlimited, included }] }
 */
export const getUsage = () => api.get("/user/usage");
